import FEATURE_FLAGS from './featureFlags';

const updateEventCurrenciesIfNeeded = (currentProps, prevProps, context) => {
  const isAdvisoryCurrencyEnabled =
    context.globalRegistry && context.globalRegistry.getFeatureValue(FEATURE_FLAGS.common.advisory.enabled);
  const {currencyExchange, events, loading, updateEventCurrencies} = currentProps;

  if (isAdvisoryCurrencyEnabled && !loading && updateEventCurrencies) {
    const eventsChanged = prevProps.events !== events; // We check the reference to check if they are the very same array
    const currencyCodeListExists =
      currencyExchange?.defaultCurrencyCodes && currencyExchange?.defaultCurrencyCodes.length > 0;
    if ((currencyExchange && !currencyCodeListExists) || eventsChanged) {
      updateEventCurrencies(events);
    }
  }
};

export {updateEventCurrenciesIfNeeded};
